module.exports = __webpack_public_path__ + "img/pink_mannequin_2_3.86c732f0.png";